import SelectablePill from './SelectablePill';
import './SelectablePill.scss';

export default SelectablePill;
